var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-add"},[_c('div',{staticClass:"add-title"},[_vm._v("新增临时用户")]),_c('base-form',{attrs:{"formType":"add"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }